angular.module 'zc.projects.campaigns', [
  'zc.core'
  'zc.users'
  'zc.projects'
  'zc.commonApi'
]





// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.campaigns/index.js.coffee